import React from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import GameListHeader from '../list/GameListHeader';
import GameList from '../list/GameList';
import { selectAllGames, selectGamesLoading, selectSearchedGames } from '@/store/games/selectors';
import { isEmpty } from '@/shared/utility';
import { RootState } from '@/models/root-state.model';
import { GAME_CATEGORY } from '../types';
import NoResultsFound from '@/pages/games/search/NoResultsFound';

export function GamesSearch({ searchValue }: { searchValue: string }): JSX.Element {
  const intl = useIntl();
  const filteredGames = useSelector((state: RootState) => selectSearchedGames(state, searchValue));
  const allGames = useSelector(selectAllGames);
  const gamesLoading = useSelector(selectGamesLoading);

  return (
    <section className="pt-12 sm:pt-20 pb-28">
      <div className="px-[16px] md:px-[32px]">
        <GameListHeader
          header={`${intl.formatMessage({ id: `games.search` })}: ${searchValue}`}
          games={allGames}
          gamesLoading={gamesLoading}
          count={!isEmpty(filteredGames) ? filteredGames.length : 0}
        />
      </div>
      {!isEmpty(filteredGames) ? (
        <GameList
          games={filteredGames}
          gamesLoading={gamesLoading}
          category={GAME_CATEGORY.SEARCH}
        />
      ) : (
        <NoResultsFound />
      )}
    </section>
  );
}
